import Layout from "../components/Layout";
import { Inventory } from "../components/_Inventory/Inventory";

const InventoryPage = (props: any) => {
    return (
        <Layout>
            <Inventory />
        </Layout>
    )
}

export default InventoryPage